import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Table,
  Button,
  Row,
  Col,
  Badge,
  Card,
  Form,
  Modal,
  Pagination,
  Offcanvas, // ----------- >
} from "react-bootstrap";
import { FiPlus, FiSearch, FiFilter, FiDownload } from "react-icons/fi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { IoIosAlert } from "react-icons/io";

import { getAttendence } from "../../store/slices/attendence";
import { getClassteacher } from "../../store/slices/classteacher";

export default function Attendance() {
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user"));
  const teacherId = user?.data?.teacherId;

  const [standardId, setStandardId] = useState("");
  const [sectionId, setSectionId] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [attendanceData, setAttendanceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [showFilterDrawer, setShowFilterDrawer] = useState(false); // ----------- >

  const location = useLocation();
  const fromAddAttendance = location.state?.fromAddAttendance;

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (fromAddAttendance && standardId && sectionId) {
      const today = getTodayDate();
      setFromDate(today);
      setToDate(today);
      fetchAttendance();
    }
  }, [fromAddAttendance, standardId, sectionId]);

  /* ->>> Fetch standardId and sectionId from  Class Teacher ------------------ */
  const fetchClassTeacher = async () => {
    try {
      const res = await dispatch(getClassteacher({ teacherId })).unwrap();
      const classteacherData = Array.isArray(res?.data) ? res.data[0] : res?.data;

      if (!classteacherData) {
        toast.error("Class teacher data not found");
        return;
      }

      setStandardId(classteacherData?.standardId?._id || "");
      setSectionId(classteacherData?.sectionId?._id || "");
    } catch {
      toast.error("Failed to fetch class teacher");
    }
  };

  useEffect(() => {
    if (teacherId) fetchClassTeacher();
  }, [teacherId]);

  /* ------------------ Fetch Attendance by date >> */
  const fetchAttendance = async () => {
    if (!fromDate || !toDate) {
      toast.error("Please select both dates");
      return;
    }

    if (new Date(fromDate) > new Date(toDate)) {
      toast.error("From Date cannot be greater than To Date");
      return;
    }

    setIsLoading(true);
    setSearchTerm("");
    setCurrentPage(1);

    try {
      const res = await dispatch(
        getAttendence({ standardId, sectionId, fromDate, toDate })
      ).unwrap();

      setAttendanceData(res?.data?.attendanceData || []);
      setShowTable(true);
      setShowDateModal(false);
    } catch (error) {
      const errorMessage =
        error?.response?.message || "Failed to fetch attendance";
      toast.error(errorMessage);
      setAttendanceData([]);
    } finally {
      setIsLoading(false);
    }
  };

  /*   Search ---->>>> */
  const attendencelistData = useMemo(() => {
    const rows = [];

    attendanceData.forEach((item) => {
      item.students?.forEach((student) => {
        rows.push({
          id: `${item._id}-${student.studentId?._id}`,
          date: item.date,
          name: student.studentId?.name || "",
          status: student.status,
        });
      });
    });

    return rows.filter((row) =>
      row.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [attendanceData, searchTerm]);

  /* > Pagination ------------------ */
  const totalPages = Math.ceil(attendencelistData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = attendencelistData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <Container>
      {/* Header */}
      <div className="staff-header">
        <div className="staff-breadcrumb">
          <Link to="/teacher/home" className="crumb home">
            Home
          </Link>
          <span className="crumb current">Attendence</span>
        </div>

        {showTable && (
          <div className="staff-header-right">
            <Link to="/teacher/add-attendance" className="btn-submit">
              <FiPlus /> Attendence
            </Link>
          </div>
        )}
      </div>

      {/* ------------------ attendence date picker Card ------------------ */}
      {!showTable && (
        <Card className="mb-4" style={{ border: "none" }}>
          <Card.Body>
            <Card.Title className="text-center">
              Get Attendence by Date
            </Card.Title>

            <Row className="align-items-end my-4">
              <Col md={6} className="mb-3">
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </Col>

              <Col md={6} className="mb-3">
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </Col>

              <Col md={4} className="mb-3 ">
                <button className="w-100 btn-submit" onClick={fetchAttendance}>
                  Get Attendance
                </button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}

      {/* ------------------ Attendence Card <<<< */}
      {showTable && (
        <Card style={{ border: "none" }}>
          <Card.Body>
            {/* ----------- > top bar */}
            <Row className="align-items-center mb-2">
              <Col md={6}>
                <h6 className="staff-card-title mb-0">
                  Attendance Overview
                </h6>
              </Col>

              <Col md={6} className="d-flex justify-content-end gap-2">
                <button
                  className="btn-cancel d-flex align-items-center gap-2"
                  onClick={() => setShowFilterDrawer(true)}
                >
                  <FiFilter />
                  <span className="d-none d-md-inline">Filter</span>
                </button>

                <button
                  className="btn-submit d-flex align-items-center gap-2"
                  onClick={() => {
                    if (!attendencelistData.length) {
                      toast.error("No data to export");
                      return;
                    }

                    const headers = ["Date", "Student Name", "Status"];
                    const rows = attendencelistData.map((r) => [
                      new Date(r.date).toLocaleDateString("en-GB"),
                      r.name,
                      r.status === 1 ? "Present" : "Absent",
                    ]);

                    const csv =
                      "data:text/csv;charset=utf-8," +
                      [headers, ...rows].map((r) => r.join(",")).join("\n");

                    const link = document.createElement("a");
                    link.href = csv;
                    link.download = "attendance_report.csv";
                    link.click();
                  }}
                >
                  <FiDownload />
                  <span className="d-none d-md-inline">Export</span>
                </button>
              </Col>
            </Row>

            {/* ----------- > search row */}
            <Row className="mb-3">
              <Col md={6}>
                <div className="staff-search d-inline-flex">
                  <FiSearch />
                  <input
                    placeholder="Search student name"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </Col>
            </Row>

            <div className="table-responsive">
              <Table className="staff-table align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Student Name</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((row, index) => (
                      <tr key={row.id}>
                        <td>{startIndex + index + 1}</td>
                        <td>{new Date(row.date).toLocaleDateString("en-GB")}</td>
                        <td>{row.name}</td>
                        <td>
                          {row.status === 1 ? (
                            <Badge bg="success">Present</Badge>
                          ) : (
                            <Badge bg="danger">Absent</Badge>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-3">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* Pagination */}
            <div className="d-flex flex-row-reverse mt-3">
              <Pagination>
                <Button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                  style={{ background: "transparent", color: "#8451ff", borderRadius: "15px" }}
                >
                  <IoIosArrowBack />
                </Button>

                <Button active disabled style={{ borderRadius: "20px" }}>
                  {currentPage}
                </Button>

                <Button
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => setCurrentPage((p) => p + 1)}
                  style={{ background: "transparent", color: "#8451ff", borderRadius: "15px" }}
                >
                  <IoIosArrowForward />
                </Button>
              </Pagination>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* ----------- > right side drawer */}
      <Offcanvas
        show={showFilterDrawer}
        onHide={() => setShowFilterDrawer(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Change Date Range</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Form.Label>From Date</Form.Label>
          <Form.Control
            type="date"
            className="mb-3"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            max={new Date().toISOString().split("T")[0]}
          />

          <Form.Label>To Date</Form.Label>
          <Form.Control
            type="date"
            className="mb-3"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            max={new Date().toISOString().split("T")[0]}
          />

          <div className="d-flex gap-2">
            <button className="btn-submit w-100" onClick={fetchAttendance}>
              Apply
            </button>
            <button
              className="btn-cancel w-100"
              onClick={() => setShowFilterDrawer(false)}
            >
              Cancel
            </button>
          </div>
          <small className="my-2"><IoIosAlert size={18} /> Modified date range</small>
        </Offcanvas.Body>
      </Offcanvas>

      {/*  >>>>> Date picked Popup ------------------ */}
      <Modal
        show={showDateModal}
        onHide={() => setShowDateModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">
            Select Date Range
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
            </Col>

            <Col md={6} className="mb-3">
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
            </Col>
          </Row>

        </Modal.Body>

        <Modal.Footer>
          <button className="btn-cancel" onClick={() => setShowDateModal(false)}>
            Cancel
          </button>
          <button className="btn-submit" onClick={fetchAttendance}>
            Apply
          </button>
          <small><IoIosAlert size={18} /> Modified date range</small>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
